import { useQuery } from '@tanstack/react-query';

import { fetchUsd1SwapPools, findUsd1SwapPoolToken } from 'lib/token/usd1SwapSubgraph';

export default function useUsd1SwapPoolToken(tokenAddress: string | undefined) {
  const poolsQuery = useQuery({
    queryKey: [ 'usd1-swap-pools' ],
    queryFn: fetchUsd1SwapPools,
    staleTime: 5 * 60 * 1000,
  });

  const poolToken = tokenAddress && poolsQuery.data ?
    findUsd1SwapPoolToken(poolsQuery.data, tokenAddress) :
    null;

  return {
    poolToken,
    isPoolsLoading: poolsQuery.isPending,
  };
}
